<div class="d-flex justify-content-end mb-4" *ngIf="statisticsData">
  <!--<p-dropdown [options]="timezones"
              [(ngModel)]="selectedTimezone"
              (onChange)="onTimezoneChange($event)"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              filterBy="label"
              [placeholder]="'COMMON.SELECT_TIMEZONE' | translate"
              styleClass="w-full me-2">
  </p-dropdown>-->

  <p-selectButton [options]="stateOptions"
                  [ngModel]="stateValue" (ngModelChange)="onStateChange($event)"
                  optionLabel="label" optionValue="value" />
</div>

<div [formGroup]="filterForm" class="row filter-row align-items-end justify-content-end">
  <div class="col-sm form-group">
    <p>{{'COMMON.ORGANISATIONS' | translate}}</p>
    <select class="form-select form-control" formControlName="selectedOrganisation"
            [compareWith]="compareObjects" (ngModelChange)="onOrganisationChanged($event)">
      <option *ngFor="let organisation of organisations" [ngValue]="organisation">
        {{ organisation.name | translate }}
      </option>
    </select>
  </div>

  <div class="col-sm form-group">
    <p>{{'COMMON.SITES' | translate}}</p>
    <select class="form-select form-control" formControlName="selectedSite" [compareWith]="compareObjects">
      <option *ngFor="let site of sites" [ngValue]="site">{{ site.name | translate }}</option>
    </select>
  </div>

  <div class="col-sm form-group">
    <p>{{'STATISTICS.FROM_DATE' | translate}}</p>
    <p-calendar formControlName="selectedPeriodStart"></p-calendar>
  </div>

  <div class="col-sm form-group">
    <p>{{'STATISTICS.TO_DATE' | translate}}</p>
    <p-calendar formControlName="selectedPeriodEnd"></p-calendar>
  </div>

  <div class="col-sm form-group">
    <p>{{'STATISTICS.TIME_INTERVAL' | translate}}</p>
    <select class="form-select form-control" formControlName="selectedTimeInterval">
      <option *ngFor="let timeInterval of timeIntervals" [value]="timeInterval">
        {{ 'STATISTICS.' + timeInterval | translate }}
      </option>
    </select>
  </div>

  <div class="col-sm form-group">
    <p>{{'STATISTICS.AGE_GROUP' | translate}}</p>
    <select class="form-select form-control" formControlName="selectedAgeGroup">
      <option [ngValue]="null">{{'COMMON.ALL' | translate}}</option>
      <option *ngFor="let ageGroup of ageGroups" [value]="ageGroup">{{ ageGroup }}</option>
    </select>
  </div>

  <div class="col-sm form-group">
    <p>{{'STATISTICS.GENDER' | translate}}</p>
    <select class="form-select form-control" formControlName="selectedGender">
      <option [ngValue]="null">{{'COMMON.ALL' | translate}}</option>
      <option *ngFor="let gender of genders" [value]="gender">{{ gender }}</option>
    </select>
  </div>

  <div class="col-sm form-group">
    <p>{{'STATISTICS.VISITOR_TYPE' | translate}}</p>
    <select class="form-select form-control" formControlName="selectedVisitorType">
      <option *ngFor="let visitorType of visitorTypes" [value]="visitorType">{{ visitorType | titlecase }}</option>
    </select>
  </div>

  <div class="col-sm form-group">
    <button class="btn btn-primary" type="button" (click)="updateStatistics()">
      {{'COMMON.UPDATE' | translate}}
    </button>
  </div>
</div>

<app-loaders *ngIf="isLoading"></app-loaders>

<ng-container *ngIf="!isLoading">
  <div class="mini-statistics d-flex flex-wrap gap-2 mb-4">
    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-account fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.TOTAL_VISITS' | translate}}</p>
        <h3 class="mb-0">{{ statisticsData.kpis.totalVisits.value }}</h3>
        <p class="mb-0">{{ statisticsData.kpis.totalVisits.previousPeriod }} {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-debug-step-into fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.ENTRIES' | translate}}</p>
        <h3 class="mb-1">{{ statisticsData.kpis.entries.value }}</h3>
        <p class="mb-0">{{ statisticsData.kpis.entries.previousPeriod }} {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-debug-step-out fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.EXITS' | translate}}</p>
        <h3 class="mb-1">{{ statisticsData.kpis.exits.value }}</h3>
        <p class="mb-0">{{ statisticsData.kpis.exits.previousPeriod }} {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-group fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.AVERAGE_OCCUPANCY' | translate}}</p>
        <h3 class="mb-1">{{ statisticsData.kpis.averageOccupancy.value }}</h3>
        <p class="mb-0">{{ statisticsData.kpis.averageOccupancy.previousPeriod }} {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-trending-up fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.PEAK_OCCUPANCY' | translate}}</p>
        <h3 class="mb-1">{{ statisticsData.kpis.peakOccupancy.value }}</h3>
        <p class="mb-0">{{ statisticsData.kpis.peakOccupancy.previousPeriod }} {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-account-multiple fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.RETURNING_RATE' | translate}}</p>
        <h3 class="mb-1">{{ statisticsData.kpis.returning[stateValue].returningCount }}</h3>
        <p class="mb-0">{{ statisticsData.kpis.returning[stateValue].rate }}% {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-autorenew fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.DOMINANT_AGE_GROUP' | translate}}</p>
        <h3 class="mb-1">{{ statisticsData.kpis.dominantAgeGroup[stateValue]?.label }}</h3>
        <p class="mb-0">{{ statisticsData.kpis.dominantAgeGroup[stateValue]?.percentage }}% {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-human-male-female fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'STATISTICS.GENDER_SPLIT' | translate}}</p>
        <h3 class="mb-1">
          {{ statisticsData.kpis.genderDistribution[stateValue]?.categories[1].percentage }}% /
          {{ statisticsData.kpis.genderDistribution[stateValue]?.categories[0].percentage }}%
        </h3>
        <p class="mb-0">
          {{ statisticsData.kpis.genderDistribution[stateValue]?.categories[1].gender }} /
          {{ statisticsData.kpis.genderDistribution[stateValue]?.categories[0].gender }}
        </p>
      </span>
    </div>
  </div>

  <ng-container *ngIf="charts && charts.length > 0">
    <div class="row">
      <div class="col-md mb-4">
        <div class="card stretch-card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.AVERAGE_OCCUPANCY_IN_A_DAY' | translate }}</h4>
            <div class="chart-container">
              <canvas baseChart
                      [type]="charts[0].type"
                      [data]="charts[0].data"
                      [options]="charts[0].options">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 mb-4">
        <div class="card stretch-card mb-2">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.AGE_GENDER_DISTRIBUTION' | translate }}</h4>
            <div class="chart-container" style="height: 250px; width: 100%;">
              <canvas baseChart
                      [type]="charts[1].type"
                      [data]="charts[1].data"
                      [options]="charts[1].options">
              </canvas>
            </div>
          </div>
        </div>

        <div class="card stretch-card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.NEW_VS_RETURNING_VISITORS' | translate: {visitorType: stateValue} }}</h4>
            <div class="chart-container">
              <div class="progress mb-4 fw-bold text-white">
                <div class="progress-bar d-flex align-items-center justify-content-center"
                     role="progressbar"
                     [style.width.%]="charts[2].data.newVisitorsPercentage"
                     [style.backgroundColor]="colors.primary"
                     [attr.aria-valuenow]="charts[2].data.newVisitorsPercentage" aria-valuemin="0" aria-valuemax="100">
                  {{ charts[2].data.newVisitorsPercentage }}%
                </div>
                <div class="progress-bar d-flex align-items-center justify-content-center"
                     role="progressbar"
                     [style.width.%]="charts[2].data.returningVisitorsPercentage"
                     [style.backgroundColor]="colors.secondary"
                     [attr.aria-valuenow]="charts[2].data.returningVisitorsPercentage" aria-valuemin="0" aria-valuemax="100">
                  {{ charts[2].data.returningVisitorsPercentage }}%
                </div>
              </div>

              <div class="flex-grow-1 w-100">
                <div class="d-flex align-items-center mb-1">
                  <span class="rounded-circle me-3" [style.backgroundColor]="colors.primary"></span>
                  <span class="flex-grow-1">{{ 'COMMON.NEW_VISITORS' | translate: {visitorType: stateValue} }}</span>
                  <span class="fw-bold">{{ charts[2].legendData.newVisitors }}</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="rounded-circle me-3" [style.backgroundColor]="colors.secondary"></span>
                  <span class="flex-grow-1">{{ 'COMMON.RETURNING_VISITORS' | translate: {visitorType: stateValue} }}</span>
                  <span class="fw-bold">{{ charts[2].legendData.returningVisitors }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 ps-0 mb-4 stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.GENDER_DISTRIBUTION' | translate: {visitorType: stateValue} }}</h4>
            <div class="chart-container">
              <div class="position-relative mb-3">
                <canvas baseChart
                        [type]="charts[3].type"
                        [data]="charts[3].data"
                        [options]="charts[3].options">
                </canvas>
                <div class="position-absolute top-50 start-50 translate-middle text-center w-100 pe-none">
                  <h3 class="mb-0 fw-bold fs-2">{{ charts[3].totalVisitors | number:'1.0-0' }}</h3>
                  <span class="text-muted small">{{'COMMON.ANALYZED_VISITORS' | translate: {visitorType: stateValue} }}</span>
                </div>
              </div>
              <div class="flex-grow-1 w-100">
                <div *ngFor="let item of charts[3].legendData" class="d-flex align-items-center mb-1">
                  <span class="rounded-circle me-3" [style.backgroundColor]="item.color"></span>
                  <span class="flex-grow-1">{{ item.label }}</span>
                  <span class="fw-bold">{{ item.percentage }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="card stretch-card">
    <div class="card-body">
      <div class="d-flex justify-content-between mb-4">
        <h4 class="card-title">{{'STATISTICS.DETAILED_DATA' | translate }}</h4>
        <button class="button btn btn-icon p-0"
                title="{{'STATISTICS.EXPORT_XLS' | translate}}"
                (click)="createExcelExport()">
          <span class="icon">
            <i class="fa fa-file-excel-o"></i>
          </span>
        </button>
      </div>

      <app-loaders *ngIf="isTableLoading"></app-loaders>
      <div *ngIf="!isTableLoading">
        <p-table [value]="tableData.rows"
                 [paginator]="true"
                 [rows]="tableData.pagination.pageSize"
                 [totalRecords]="tableData.pagination.totalRows"
                 [first]="first"
                 [lazy]="true"
                 (onLazyLoad)="loadDataLazy($event)"
                 [showCurrentPageReport]="true"
                 [tableStyle]="{ 'min-width': '50rem' }"
                 [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries' | translate"
                 [rowsPerPageOptions]="[10, 25, 50, 100]">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'STATISTICS.DATE' | translate }}</th>
              <th>{{ 'STATISTICS.SITE' | translate }}</th>
              <th>{{ 'STATISTICS.IN' | translate }}</th>
              <th>{{ 'STATISTICS.OUT' | translate }}</th>
              <th>{{ 'STATISTICS.INSIDE' | translate }}</th>
              <th>{{ 'STATISTICS.AGE_GROUP' | translate }}</th>
              <th>{{ 'STATISTICS.GENDER' | translate }}</th>
              <th>{{ 'STATISTICS.RETURNING_RATE' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data>
            <tr>
              <td>{{ data.periodStart.split('T')[0] }} {{ data.periodStart.split('T')[1].substring(0, 5) }}</td>
              <td>{{ data.locationName }}</td>
              <td class="text-success">{{ data.entries }}</td>
              <td class="text-danger">{{ data.exits }}</td>
              <td class="text-info">{{ data.peakOccupancy }}</td>
              <td>{{ data[stateValue].dominantAgeGroup?.ageGroup }}</td>
              <td>{{ data[stateValue].dominantGender?.gender | titlecase }}</td>
              <td>{{ data[stateValue].returningRate }}%</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

</ng-container>
